var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 1950,
        width: 2270,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { height: "120", width: "2270", y: "0", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "360", width: "2270", y: "140", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "560", width: "2270", y: "520", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "760", width: "2270", y: "1100", x: "0", rx: "5" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }